import React from "react";
import "../../index.css";
import "../../App.css";
import { Row, Col, Typography } from "antd";
import MaleBodyViewer from "../../MaleBodyViewer";

const PainDurationSelector = () => {
  return (
    <div className="flex flex-col gap-2">
      <label className="h6 text-theme-text-secondary">
        <strong>Pain location *</strong>
      </label>
      <p className="body1 text-theme-text-primary mb-4">
        Select the areas where you have pain. You'll see pain frequency over time as you log.
      </p>
      <MaleBodyViewer isBodyClickEnable={true} />
    </div>
  );
};

export default PainDurationSelector;
